import FrontendUser from 'umg-ember-backend/components/record-explorer/for/frontend-user';

<template>
  <FrontendUser @records={{@model}} @recordType='frontend-user' />
</template>
